export default __webpack_public_path__ + "static/media/marker-default.e1ef4074.svg";